import { ICommonInsuranceParams } from '@app/pages/quote/insurance/insurance-model';
import { TaxType } from '@app/pages/quote/open-quote/model/open-quote.model';
import { calculateDto, customerDto, FinancialProductEnum } from '@app/pages/quote/standard-quote/model/standard-quote.model';
import { InsuranceTypeEnum } from '@app/services/insurance.service';

export class PureLeaseMarshStandard {
  subsidyTotal: number | null;
  subsidyType: string | null;
  nameCompany: string;
  financialProduct: string;
  currency: string;
  calculationType: string;
  maturityType: string;
  quantity: number;
  insuranceAmount: number;
  unitPrice: number;
  confirmationExpensesAmount: number;
  lifeInsuranceAmount: number;
  term: number;
  taxFree: boolean;
  customerRate: number;
  openingFeeType: string;
  openingFeePercentage: number | null;
  openingFee: number | null;
  gracePeriodApplyTo: any;
  gracePeriod: any;
  specialPayments: any;
  grace: any;
  residualValuePercentage: any;
  personType: any;
  financialSetupId: any;
  financialConditionId: any;
  purchasePercentage: any;
  residualValueTotal: number;
  residualValueType: string;
  balloonPercentage: any;
  balloon: any;
  downPaymentTaxType: any;
  downPaymentTax: any;
  downPayment: any;
  warrantyDeposit: any;
  warrantyDepositMonth: any;
  warrantyDepositPercentage: any;
  warrantyDepositTotal: any;

  constructor(form: any, params: ICommonInsuranceParams, customer: customerDto | null, data: any) {
    const insuranceType = form.insuranceType;
    const isAnnualInsurance = insuranceType === InsuranceTypeEnum.COUNTED_ANNUAL || insuranceType === InsuranceTypeEnum.FINANCED_ANNUAL;
    const isTermMoreThan12 = data.financialSetup.financialCondition.term > 12;
    const marshTerm = isAnnualInsurance && isTermMoreThan12 ?  12 :  data.financialSetup.financialCondition.term;
    this.personType = customer?.personType;
    this.nameCompany = params.companyName;
    this.financialProduct = FinancialProductEnum.pureLease;
    this.currency = params?.currency || "";
    this.calculationType = params?.paymentFormationType || "";
    this.maturityType = params?.paymentType || "";
    this.quantity = params?.quantity!;
    this.insuranceAmount = 0;
    this.unitPrice = form?.packageList?.amount;
    this.confirmationExpensesAmount = 3886;
    this.lifeInsuranceAmount = 0;
    this.term = marshTerm;
    // Convertir taxFree a boolean (puede venir como string "true"/"false" o boolean)
    const taxFreeValue = data.financialSetup?.taxFree;
    this.taxFree = taxFreeValue === true || taxFreeValue === "true" || taxFreeValue === "TRUE" || false;
    this.customerRate = data.financialSetup.financialCondition.nominalRate;
    this.openingFeeType = data.financialSetup.openingFeeType;
    this.openingFeePercentage = data.financialSetup.openingFeeTax;
    this.openingFee = null;
    this.gracePeriodApplyTo = 'CAPITAL';
    this.gracePeriod = 1;
    this.grace = data.grace;

    this.downPaymentTaxType = TaxType.invoiceWithoutTax;
    this.downPaymentTax = 0;
    this.downPayment = null;

    this.financialSetupId = data.financialSetup.id;
    this.financialConditionId = data.financialSetup.financialCondition.id;

    this.residualValueType = TaxType.fixedAmount as string;
    this.residualValuePercentage = null;
    this.residualValueTotal = 0;

    this.warrantyDeposit =  TaxType.fixedAmount as string;
    this.warrantyDepositMonth = null;
    this.warrantyDepositPercentage = null;
    this.warrantyDepositTotal = 0;

    this.balloon = null;
    this.balloonPercentage = null;
    this.specialPayments = null;
  }
}
